import {
  createFilterFormStore,
  usePersistedFilterFormik,
} from "../../../util/usePersistedFilterFormik";
import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

// observable store
const warehouseFilterStore = makeObservable({});
const warehouseNavigationStore =
  createSearchResultNavigationStore(warehouseFilterStore);

const toWarehouseFilter = values =>
  convertToFilter({
    values,
    filterKeys: ["tab"],
    skipKeys: ["limit", "offset"],
  });

const filterFormStore = createFilterFormStore(
  "warehouse",
  warehouseFilterStore,
  warehouseNavigationStore,
  { toFilter: toWarehouseFilter },
);

const useWarehouseFilters = () => {
  const formik = usePersistedFilterFormik(
    {
      initialValues: {
        categoryId: {
          operator: "in",
        },
        destroyed: 0,
        limit: 50,
        offset: 0,
        tab: "instance",
      },
    },
    filterFormStore,
  );

  useEffect(() => {
    warehouseFilterStore.set(toWarehouseFilter(formik.values));
  }, [formik.values]);

  return {
    formik,
  };
};

export { warehouseFilterStore, warehouseNavigationStore, useWarehouseFilters };
